import { isPlatformTizen } from '@rnv/renative';

const TIZEN_KEYS = [
  'MediaPlayPause',
  'MediaPlay',
  'MediaPause',
  'MediaStop',
  'MediaRewind',
  'MediaFastForward',
  'MediaTrackPrevious',
  'MediaTrackNext',
  'ColorF0Red',
  'ColorF1Green',
  'ColorF2Yellow',
  'ColorF3Blue',
  'Exit',
  'Info',
  'ChannelUp',
  'ChannelDown',
];

export const registerTvKeys = () => {
  if (typeof window === 'undefined') return;
  if (!isPlatformTizen) return;
  try {
    (window as any).tizen?.tvinputdevice?.registerKeyBatch?.(TIZEN_KEYS);
  } catch {}
};
